/**
 * Owner: Masa Bayu
 * File: batch04-fixtures.ts
 * Date:Time: 2026-09-20 00:15
 * Description: Batch 4 certification fixtures — SEA no-space scripts.
 */
import {} from './batch04-codes';
function fixturesFor(familyId, scriptLabel) {
    return Object.freeze([
        Object.freeze({
            id: `fixture:${familyId}/identity`,
            familyId,
            area: 'identity',
            description: `canonical languageId samples for ${familyId}`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/script-character`,
            familyId,
            area: 'script',
            description: `${scriptLabel} script / character identity`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/direction-ltr`,
            familyId,
            area: 'direction',
            description: 'LTR default + explicit ltr override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/content-multilingual`,
            familyId,
            area: 'content',
            description: 'primary + contentLanguages',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxw-author-preserve`,
            familyId,
            area: 'qxw',
            description: 'QXW root metadata author → preserve',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxp-publish-preserve`,
            familyId,
            area: 'qxp',
            description: 'QXP artifact preserve-through-publish',
        }),
        Object.freeze({
            id: `fixture:${familyId}/reader-typography`,
            familyId,
            area: 'reader',
            description: 'SEA complex shaping typography stacks',
        }),
        Object.freeze({
            id: `fixture:${familyId}/search-nospace-segment`,
            familyId,
            area: 'search',
            description: 'NFC + script-aware analyzer · forbid whitespace word-boundary default',
        }),
        Object.freeze({
            id: `fixture:${familyId}/navigation-structure`,
            familyId,
            area: 'navigation',
            description: 'writing mode + heading role metadata',
        }),
        Object.freeze({
            id: `fixture:${familyId}/annotation-anchors`,
            familyId,
            area: 'annotation',
            description: 'original text preserved for selection/annotation anchors',
        }),
        Object.freeze({
            id: `fixture:${familyId}/a11y-lang-semantics`,
            familyId,
            area: 'accessibility',
            description: 'content lang + reading order without whitespace word assumptions',
        }),
        Object.freeze({
            id: `fixture:${familyId}/serialize-roundtrip`,
            familyId,
            area: 'serialization',
            description: 'metadata / content round-trip',
        }),
        Object.freeze({
            id: `fixture:${familyId}/regression-suite`,
            familyId,
            area: 'regression',
            description: 'content id stable under override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/provenance-chain`,
            familyId,
            area: 'provenance',
            description: 'source → evidence area trace',
        }),
    ]);
}
export const QX_BATCH_04_THAI_FIXTURES = fixturesFor('thai', 'Thai');
export const QX_BATCH_04_LAO_FIXTURES = fixturesFor('lao', 'Laoo');
export const QX_BATCH_04_KHMER_FIXTURES = fixturesFor('khmer', 'Khmr');
export const QX_BATCH_04_MYANMAR_FIXTURES = fixturesFor('myanmar', 'Mymr');
export const QX_BATCH_04_FIXTURES = Object.freeze([
    ...QX_BATCH_04_THAI_FIXTURES,
    ...QX_BATCH_04_LAO_FIXTURES,
    ...QX_BATCH_04_KHMER_FIXTURES,
    ...QX_BATCH_04_MYANMAR_FIXTURES,
]);
export const QX_BATCH_04_THAI_SAMPLE_LANGUAGES = Object.freeze(['th']);
export const QX_BATCH_04_LAO_SAMPLE_LANGUAGES = Object.freeze(['lo']);
export const QX_BATCH_04_KHMER_SAMPLE_LANGUAGES = Object.freeze(['km']);
export const QX_BATCH_04_MYANMAR_SAMPLE_LANGUAGES = Object.freeze(['my']);
export const QX_BATCH_04_TEXT_SAMPLES = Object.freeze({
    th: 'สวัสดีชาวโลก—ตัวอย่างการรับรองภาษาไทยไม่มีช่องว่างคำ',
    lo: 'ສະບາຍດີໂລກ—ຕົວຢ່າງການຮັບຮອງພາສາລາວ',
    km: 'សួស្តីពិភពលោក—គំរូវិញ្ញាបនបត្រភាសាខ្មែរ',
    my: 'မင်္ဂလာပါကမ္ဘာ—မြန်မာစာအသိအမှတ်ပြုနမူနာ',
    composed: 'cafe\u0301',
});
const BY_FAMILY = Object.freeze({
    thai: QX_BATCH_04_THAI_FIXTURES,
    lao: QX_BATCH_04_LAO_FIXTURES,
    khmer: QX_BATCH_04_KHMER_FIXTURES,
    myanmar: QX_BATCH_04_MYANMAR_FIXTURES,
});
export function listBatch04FixtureIds(familyId) {
    const list = familyId ? BY_FAMILY[familyId] : QX_BATCH_04_FIXTURES;
    return Object.freeze(list.map((f) => f.id));
}
export function fixturesForBatch04Family(familyId) {
    return BY_FAMILY[familyId];
}
//# sourceMappingURL=batch04-fixtures.js.map